import { useEffect } from 'react';
import { creatorApi } from '../data/creator.api';

/** Acknowledge only an answer loaded in a visible conversation. */
export function useSupportTicketView(ticketId: string | null, pendingAnswerAt: string | null | undefined) {
  useEffect(() => {
    if (!ticketId || !pendingAnswerAt) return;
    const acknowledge = () => {
      if (document.visibilityState === 'visible') {
        void creatorApi.acknowledgeAnswer(ticketId, pendingAnswerAt).catch(() => {});
      }
    };
    acknowledge();
    document.addEventListener('visibilitychange', acknowledge);
    return () => document.removeEventListener('visibilitychange', acknowledge);
  }, [ticketId, pendingAnswerAt]);
}
